export const API_DATE_FORMAT = "yyyy-MM-dd";

// API format : 'YYYY-MM-DD'
// Frontend format: MM/DD/YYYY

export function convertToAPIDate(date?: string) {
  if (!date) return "";
  if (date.includes("-")) return date;
  const [month, day, year] = date.split("/");
  return `${year}-${month}-${day}`;
}
